<form
  class="ie-w-100 ie-h-100 d-flex flex-column flex-md-row align-items-md-end justify-content-center"
  [formGroup]="form"
  (ngSubmit)="sumbitForm()"
>
  <div class="row ie-w-100 ie-h-100">
    <ng-container
      [ngTemplateOutlet]="inputTemplate"
      [ngTemplateOutletContext]="{ name: 'orderNumber', label: 'SEARCH.ORDER_NUMBER' | translate }"
    ></ng-container>

    <ng-container
      [ngTemplateOutlet]="inputTemplate"
      [ngTemplateOutletContext]="{ name: 'pnr', label: 'SEARCH.PNR' | translate }"
    ></ng-container>

    <ng-container
      [ngTemplateOutlet]="inputTemplate"
      [ngTemplateOutletContext]="{ name: 'name', label: 'SEARCH.MAINBOOKER_NAME' | translate }"
    ></ng-container>
  </div>

  <div class="pb-md-3 pl-md-4">
    <button type="submit" class="btn btn-primary text-nowrap w-100" [disabled]="loading">
      <i class="mdi mdi-magnify"></i> {{ 'SEARCH.SEARCH' | translate }}
    </button>
  </div>

  <ng-template #inputTemplate let-name="name" let-label="label">
    <div class="col-12 col-md-4">
      <label [htmlFor]="name">{{ label }}</label>

      <div class="input-group mb-3">
        <input
          type="text"
          class="form-control"
          aria-autocomplete="both"
          aria-haspopup="false"
          autocapitalize="off"
          autocomplete="off"
          autocorrect="off"
          role="combobox"
          spellcheck="false"
          aria-label="Search"
          [id]="name"
          [formControlName]="name"
        />
      </div>
    </div>
  </ng-template>
</form>
